export function isAdvertiserSelectDisabled(
  status: string | undefined,
  startDate: Date | null | undefined
): boolean {
  if (status !== 'ACTIVE') return false;

  const today = new Date();
  today.setHours(0, 0, 0, 0);

  return startDate != null && startDate <= today;
}
